import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'SiteStopButton',
  props: {
    text: null,
    highlighted: { type: Boolean },
    viewSize: { default: 'Large' }
  },
  setup(__props: any) {

const props = __props as { text: string, highlighted?: boolean, viewSize: string }

// eslint-disable-next-line @typescript-eslint/no-unused-vars


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([`${props.highlighted ? 'bg-poppy' : 'bg-stone'} ${
      props.viewSize.toLowerCase() == 'large'
        ? 'text-headingLg'
        : 'text-headingXl'
    }`, "site-stop-btn rounded-full hover:bg-poppy flex w-[92px] h-[92px] items-center justify-center text-slateGray font-bold cursor-pointer"])
  }, _toDisplayString(props.text), 3))
}
}

})